import React from "react";
import { ExternalLink, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const portfolioItems = [{
  id: 1,
  title: "Power Shine Solar Cleaning",
  industry: "Cleaner",
  image: "https://websiteshop.com.au/wp-content/uploads/2026/04/PowerShine-Screenshot-scaled.png?v=lsge8cudzwa",
  height: "h-[450px]",
  description: "Luxury commercial cleaning delivering spotless environments for offices, gyms, strata, and professional spaces.",
  link: "https://powershine.com.au",
  newTab: true
}, {
  id: 2,
  title: "Height Safety Compliance Systems",
  industry: "Roof Safety",
  image: "https://websiteshop.com.au/wp-content/uploads/2026/03/HSC-Screenshot-scaled.png?v=f8jyxy1476r",
  height: "h-[320px]",
  description: "Professional height safety installation and certification to keep your workplace compliant and secure.",
  link: "https://hscsystemscom.au",
  newTab: true
}, {
  id: 3,
  title: "Premium Detailing Studio",
  industry: "Detailer",
  image: "https://websiteshop.com.au/wp-content/uploads/2026/03/PDS-Screenshot-scaled.png?v=uneilgadq4",
  height: "h-[380px]",
  description: "Precision automotive detailing with showroom-quality results.",
  link: "https://www.premiumdetailingstudio.com.au",
  newTab: true
}, {
  id: 5,
  title: "Pristine Coat Painting",
  industry: "Painter",
  image: "https://websiteshop.com.au/wp-content/uploads/2026/03/Screenshot-3-scaled.png?v=ew0021hhpjo",
  height: "h-[300px]",
  description: "Premium residential and commercial painting with flawless finishes and meticulous attention to detail.",
  link: "https://pristinecoatpainting.com.au",
  newTab: true
}, {
  id: 6,
  title: "Website Shop",
  industry: "Website Developer",
  image: "https://websiteshop.com.au/wp-content/uploads/2026/03/Website-Shop-Portfolio-scaled.png?v=ll2queimjjt",
  height: "h-[420px]",
  description: "Like what you see? Contact us today and let us know you'd like a modern, dark vibe.",
  link: "/ContactPage",
  newTab: false
}, {
  id: 7,
  title: "Cliff Hanger Plumbing",
  industry: "Plumber",
  image: "https://websiteshop.com.au/wp-content/uploads/2026/04/Cliffhanger-scaled.png?v=3iy1hn056dj",
  height: "h-[400px]",
  description: "Reliable 24/7 emergency plumbing services for residential and commercial clients across the Central Coast.",
  link: "https://cliffhangerplumbing.com.au",
  newTab: true
}, {
  id: 9,
  title: "Coastal Prestige Mowing & Maintenance",
  industry: "Plumbing",
  image: "https://websiteshop.com.au/wp-content/uploads/2026/04/Coastal-prestige-scaled.png?v=38u4dvwx4ss",
  height: "h-[360px]",
  description: "Luxury mowing & maintenance specialist servicing the Northern End of the Central Coast.",
  link: "https://coastalprestigemowing.com.au",
  newTab: true
}];
export default function TheWorkroom() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="the-workroom" className="bg-background text-foreground py-20 px-4 md:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex flex-col justify-between items-end gap-6 ![margin:0px_70px_48px_0px] md:flex-row">
          <div className="max-w-2xl">
            <h2 className="text-primary font-medium tracking-wide uppercase text-sm mb-3">
              Our Portfolio
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-4">
              The Workroom
            </h3>
            <p className="text-muted-foreground text-lg max-w-xl">Showcasing our best work.</p>
          </div>
          <div className="hidden md:block">
            <Button variant="outline" className="rounded-full border-primary/20 hover:border-primary/50 hover:bg-primary/10 text-foreground" asChild>
              <Link to="/PortfolioPage">
                View Full Portfolio <ArrowUpRight className="ml-2 size-4" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div ref={ref} className={`columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {portfolioItems.map((item, i) => <div key={item.id} data-index={i} className="break-inside-avoid mb-6">
              {item.id === 5 ? <Link to={item.link} newTab={item.newTab} className="group relative block rounded-xl overflow-hidden border border-border/50 bg-card shadow-lg hover:shadow-primary/10 hover:border-primary/30 transition-all duration-500 no-underline">
                  <div className={`relative w-full ${item.height} overflow-hidden bg-muted`}>
                    <img src={item.image} alt={`${item.title} website preview`} className="w-full h-auto object-top transition-transform duration-[5000ms] ease-in-out group-hover:-translate-y-[calc(100%-450px)]" />
                    
                    <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300" />
                    
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/40 backdrop-blur-[2px]">
                      <Button size="lg" className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 font-semibold shadow-xl scale-90 group-hover:scale-100 transition-transform duration-300 relative z-20">
                        View Live Site <ExternalLink className="ml-2 size-4" />
                      </Button>
                    </div>
                  </div>

                  <div className="absolute bottom-0 left-0 w-full p-5 bg-gradient-to-t from-black/90 to-transparent pt-12">
                    <div className="flex justify-between items-start mb-2">
                      <Badge variant="secondary" className="bg-primary/20 text-primary hover:bg-primary/30 border-primary/20 backdrop-blur-md">
                        {item.industry}
                      </Badge>
                    </div>
                    <h4 className="text-xl font-bold text-white mb-1 group-hover:text-primary transition-colors">
                      {item.title}
                    </h4>
                    <p className="text-sm text-gray-300 line-clamp-2 opacity-0 h-0 group-hover:opacity-100 group-hover:h-auto transition-all duration-300 delay-75">
                      {item.description}
                    </p>
                  </div>
                </Link> : <Link to={item.link} newTab={item.newTab} className="group relative block rounded-xl overflow-hidden border border-border/50 bg-card shadow-lg hover:shadow-primary/10 hover:border-primary/30 transition-all duration-500 no-underline">
                  <div className={`relative w-full ${item.height} overflow-hidden bg-muted`}>
                    <img src={item.image} alt={`${item.title} website preview`} className="w-full h-auto object-top transition-transform duration-[5000ms] ease-in-out group-hover:-translate-y-[calc(100%-450px)]" />
                    
                    <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300" />
                    
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/40 backdrop-blur-[2px]">
                      <Button size="lg" className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 font-semibold shadow-xl scale-90 group-hover:scale-100 transition-transform duration-300">
                        View Live Site <ExternalLink className="ml-2 size-4" />
                      </Button>
                    </div>
                  </div>

                  <div className="absolute bottom-0 left-0 w-full p-5 bg-gradient-to-t from-black/90 to-transparent pt-12">
                    <div className="flex justify-between items-start mb-2">
                      <Badge variant="secondary" className="bg-primary/20 text-primary hover:bg-primary/30 border-primary/20 backdrop-blur-md">
                        {item.industry}
                      </Badge>
                    </div>
                    <h4 className="text-xl font-bold text-white mb-1 group-hover:text-primary transition-colors">
                      {item.title}
                    </h4>
                    <p className="text-sm text-gray-300 line-clamp-2 opacity-0 h-0 group-hover:opacity-100 group-hover:h-auto transition-all duration-300 delay-75">
                      {item.description}
                    </p>
                  </div>
                </Link>}
            </div>)}
        </div>

        <div className="mt-10 text-center md:hidden">
           <Button variant="outline" className="w-full rounded-full border-primary/20 hover:border-primary/50 hover:bg-primary/10 text-foreground" asChild>
              <Link to="/PortfolioPage">
                View Full Portfolio <ArrowUpRight className="ml-2 size-4" />
              </Link>
            </Button>
        </div>
      </div>
    </section>;
}